"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ErrorMessage;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _Text = _interopRequireDefault(require("./Text"));
var _excluded = ["style"];
function ErrorMessage(props) {
  var style = props.style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    style: [styles.errorMessage, style]
  }, rest));
}
ErrorMessage.propTypes = _Text["default"].propTypes;
var styles = _reactNative.StyleSheet.create({
  errorMessage: {
    // textTransform: 'capitalize',
    textAlign: 'center',
    color: _styles.colors.error
  }
});